export default __webpack_public_path__ + "static/media/11-2.80d4cf3d.jpg";